import { useBreakpoint } from "@mailbrew/uikit";

export default function useBiggerTouchButtonsStyle() {
  const biggerButton = useBreakpoint(480);
  return { fontSize: "80%", zoom: biggerButton ? 1.15 : 1 };
}
